import React, { PropTypes } from 'react';
import ManipButtons from '../ManipButtons';

const formatCaptures = (manip, insectsRef) => {
  const selectedSpecies = manip.species.map(s => Number.parseInt(s, 10));
  const species = manip.species_captures
    .map(cap => {
      const insectId = Number.parseInt(cap.species, 10);
      const capture = Number.parseInt(cap.value, 10);

      if (insectsRef) {
        const insect = insectsRef.find(i => i.id === insectId);

        if (
          insect &&
          capture !== undefined &&
          capture !== null &&
          !isNaN(capture) &&
          selectedSpecies.includes(insectId)
        ) {
          return `${insect.label} : ${capture}<br />`;
        } else if (insect && selectedSpecies.includes(insectId)) {
          return `${insect.label}<br />`;
        }
      }

      return '';
    })
    .join('');

  let other = '';
  const otherCapture = manip.species_other_capture;

  if (
    manip.species_other &&
    otherCapture !== undefined &&
    otherCapture !== null
  ) {
    other = `${manip.species_other} : ${otherCapture}`;
  } else if (manip.species_other) {
    other = `${manip.species_other} `;
  }
  const result = species + other;

  return {
    __html: result,
  };
};

const InsectItem = ({
  manip,
  onUpdated,
  onDeleted,
  insectsRef,
  capturesRef,
  disabled = false,
}) => (
  <tr>
    <ManipButtons
      manip={manip}
      onUpdated={onUpdated}
      onDeleted={onDeleted}
      hideHistory={false}
      disabled={disabled}
    />
    <td>{manip.number}</td>
    <td>{manip.product_name}</td>
    <td>{manip.manip_name}</td>
    <td>{manip.comp_product_name}</td>
    <td>{manip.comp_manip_name}</td>
    <td dangerouslySetInnerHTML={formatCaptures(manip, insectsRef)} />
  </tr>
);

InsectItem.propTypes = {
  manip: PropTypes.object.isRequired,
  onUpdated: PropTypes.func.isRequired,
  onDeleted: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default InsectItem;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/types/InsectItem.js